import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, Crown, Loader2 } from "lucide-react";

export const FEATURE_PLAN = { ai: "Profissional", team: "Empresa", contracts: "Empresa" };

let cache = null;
export const usePlanFeature = (feature) => {
  const [sub, setSub] = useState(cache);
  useEffect(() => {
    api.get("/subscription").then(({ data }) => { cache = data; setSub(data); }).catch(() => setSub({ info: {} }));
  }, []);
  return { loading: !sub, allowed: !!sub?.info?.[feature], sub };
};

export const PlanGate = ({ feature, title, description, children }) => {
  const { loading, allowed } = usePlanFeature(feature);
  if (loading) return <div className="h-40 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (allowed) return children;
  return (
    <Card className="p-6 sm:p-8 text-center space-y-3 border-dashed" data-testid={`plan-gate-${feature}`}>
      <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-500/10 text-amber-600 flex items-center justify-center"><Lock className="h-7 w-7" /></div>
      <h2 className="font-display font-bold text-lg md:text-xl">{title}</h2>
      <p className="text-sm text-muted-foreground max-w-md mx-auto">{description}</p>
      <p className="text-xs font-semibold text-amber-700 dark:text-amber-300">Disponível a partir do plano {FEATURE_PLAN[feature]}</p>
      <Button asChild className="h-11"><Link to="/plans" data-testid={`plan-gate-upgrade-${feature}`}><Crown className="h-4 w-4 mr-1" /> Ver planos e fazer upgrade</Link></Button>
    </Card>
  );
};
